import { Component, Input} from '@angular/core';
import { AbstractDialogComponent } from '../../../../Core/Dialogs/components/AbstractDialog/abstract-dialog.component';
import { FullProfileAnimationModel } from '../../../../Core/Dialogs/models/full-profile-animation.model';
import {Observable} from 'rxjs';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { MonitoringQuotaTypesEnum } from '../../../../api/mentions/enum/monitoring-quota-types.enum';

@Component({
    selector: 'agpr-quota-usage-widget',
    templateUrl: './quota-usage-widget.component.html',
    styleUrls: ['./quota-usage-widget.component.scss'],
    standalone: false
})
export class QuotaUsageWidgetComponent extends AbstractDialogComponent {
    static readonly DIALOG_KEY: string = 'QuotaUsageWidget';

    @Input() overlayContainer: Element;
    @Input() animationTrigger: Observable<FullProfileAnimationModel>;
    @Input() selectedStartDate: Date;

    quotaType?: MonitoringQuotaTypesEnum;

    constructor(coreDialogService: CoreDialogService) {
        super(coreDialogService, QuotaUsageWidgetComponent.DIALOG_KEY);
    }
}
